// Types
import * as Types from './types';
import { requestActionProps, requestGenerate, successGenerate } from '../common';
import api from '../../services/api';
import { ILogin, callbackProps, IAuthInfoModel, ID, IAuthUserToken } from "../../constants";

const actionLogin = (
  payload: ILogin,
  callback?: (a: callbackProps) => void,
): requestActionProps => ({
  type: requestGenerate(Types.REQUEST),
  api: api.staffLogin,
  payload: { data: payload },
  callback,
});

const actionGetStaffLoginInfo = (
  payload:ID,
  callback?: (a: callbackProps) => void
): requestActionProps => ({
  type: requestGenerate(Types.REQUEST),
  api: api.getStaffLoginInfo,
  payload: { data:payload  },
  callback,
});

const actionSaveLogin = (
  payload: IAuthInfoModel,
) => ({
  type: successGenerate(Types.LOGIN_REQUEST),
  payload: {data: payload},
});

const actionLoginSuccess = (payload: any) => ({
  type: successGenerate(Types.REFRESH_TOKEN),
  payload: payload,
});

const actionExit = (
) => ({
  type: successGenerate(Types.LOG_OUT),
});

// Export
export {
  actionLogin,
  actionExit,
  actionLoginSuccess,
  actionSaveLogin,actionGetStaffLoginInfo
};
